import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { statusSchedule } from '../../view-agenda/view-agenda.component';
import { EditarAgendamentoComponent } from "../editar-agendamento/editar-agendamento.component";
import { AlertComponent } from "../../../../../alert/alert.component";
import { LoadingModalComponent } from "../../../../../loading-modal/loading-modal.component";
import { CriarAgendamentoComponent } from "../../criar-agendamento/criar-agendamento.component";
import { RemarcarAgendamentoComponent } from "../remarcar-agendamento/remarcar-agendamento.component";


@Component({
  selector: 'app-encaixe-agendamento',
  standalone: true,
  imports: [CommonModule, EditarAgendamentoComponent, AlertComponent, LoadingModalComponent, CriarAgendamentoComponent, RemarcarAgendamentoComponent],
  templateUrl: './encaixe-agendamento.component.html',
  styleUrls: ['./encaixe-agendamento.component.scss'],
})
export class EncaixeAgendamentoComponent implements OnInit {
  @Input() objectData: any;
  @Input() objectDefaultInfoAppointment: any;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() requestUpdateAppointment: EventEmitter<void> = new EventEmitter<void>();


  public listEncaixes: Array<any> = [];
  public statusSchedules = statusSchedule;

  public openModalEditAppointment: boolean = false;
  public appointmentSelectedEdit: any;


  //This variable is about a open modal create new fitting
  public openModalNewFitting: boolean = false;
  public appointmentSelectedReeschedule: any;


  //This variable is about a open modal Reeschedule Fitting
  public openModalReescheduleFitting: boolean = false;

  constructor() {}

  ngOnInit() {
    for (let item of this.objectData) {
      this.listEncaixes.push(item);
    }
  }

  calcularDuracao(horaInicio: string, horaFim: string): string {
    const [hora1, minuto1] = horaInicio.split(':').map(Number);
    const [hora2, minuto2] = horaFim.split(':').map(Number);

    const minutosInicio = hora1 * 60 + minuto1;
    const minutosFim = hora2 * 60 + minuto2;

    let duracaoMinutos = minutosFim - minutosInicio;

    // Ajusta caso tenha passado da meia-noite
    if (duracaoMinutos < 0) {
      duracaoMinutos += 24 * 60;
    }

    return `${duracaoMinutos} min`;
  }

  translationStatus(status: keyof typeof statusSchedule){
    return this.statusSchedules[status];
  }

  count(): number { 
    return this.listEncaixes.length;
  }

  handleCloseModal() {
    this.closeModal.emit();
  }


  openModalEdit(appointment: any){
    this.openModalEditAppointment = true;
    this.appointmentSelectedEdit = appointment;
  }

  closeModalEditAppointment(){
    this.openModalEditAppointment = false;
  }

  handleRequestUpdateAppointment(){
    this.requestUpdateAppointment.emit();
  }


  //This functions reeschedule a fitting
  handleOpenModalReescheduleFitting(appointment: any){
    this.appointmentSelectedReeschedule = appointment;
    this.openModalReescheduleFitting = true;
  }

  handleCloseModalReescheduleFitting(){
    this.openModalReescheduleFitting = false;
  }



  //The functions of create a new fitting
  handleOpenModal(){
    console.log(this.objectDefaultInfoAppointment);
    this.openModalNewFitting = true;
  }

  handleCloseModalNewFitting(){
    this.openModalNewFitting = false;
    this.handleRequestUpdateAppointment();
  }

}
